// Thin Overpass API client with endpoint failover and one retry pass.

const ENDPOINTS = [
  "https://overpass-api.de/api/interpreter",
  "https://overpass.kumi.systems/api/interpreter",
  "https://overpass.private.coffee/api/interpreter",
];

const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

// `endpointOffset` rotates which mirror is tried first — parallel callers
// spread across mirrors instead of queueing on one server's per-IP slots.
export const overpassQuery = async (
  query,
  { retries = 1, endpointOffset = 0, timeoutMs = 120000 } = {}
) => {
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt++) {
    for (let i = 0; i < ENDPOINTS.length; i++) {
      const endpoint = ENDPOINTS[(endpointOffset + i) % ENDPOINTS.length];
      try {
        const resp = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: `data=${encodeURIComponent(query)}`,
          signal: AbortSignal.timeout(timeoutMs),
        });
        if (!resp.ok) throw new Error(`Overpass HTTP ${resp.status}`);
        return await resp.json();
      } catch (err) {
        lastErr = err;
        console.warn(`Overpass endpoint failed (${endpoint}):`, err.message);
      }
    }
    if (attempt < retries) await sleep(2000);
  }
  throw lastErr;
};
